import { render, staticRenderFns } from "./BreakView.vue?vue&type=template&id=35381170"
import script from "./BreakView.vue?vue&type=script&lang=js"
export * from "./BreakView.vue?vue&type=script&lang=js"
import style0 from "./BreakView.vue?vue&type=style&index=0&id=35381170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports